import * as React from 'react'
import {
  Box,
  Flag,
  Icon,
  Inline,
  Radio,
  TableBodyCell,
  TableRow,
  Text,
} from '@lightspeed/design-system-react'
import { DATE_MEDIUM_FULL, formatDateTime } from '@vend/utilities'
import { useT } from '@transifex/react'
import { toHoursAndMinutes } from '../../../../../../util/agenda-utils'
import { ServiceAgenda } from '../../../../../../models/sale.constants'
import { compareDates } from '../../utilities'
interface Props {
  selectedDate?: string
  setSelectedDate: (date: string) => void
  totalMinutesScheduled: number
  agenda: ServiceAgenda
}

export const SelectADateRow: React.FC<Props> = ({
  setSelectedDate,
  selectedDate,
  totalMinutesScheduled,
  agenda,
}) => {
  const { date, minutesScheduled } = agenda
  const {
    hours: scheduledHours,
    minutes: scheduledMinutes,
  } = toHoursAndMinutes(minutesScheduled)

  const formattedCurrentDate = formatDateTime(date, DATE_MEDIUM_FULL)

  const shouldUseTodayFlag =
    formatDateTime(new Date(), DATE_MEDIUM_FULL) ===
    formatDateTime(date, DATE_MEDIUM_FULL)

  const t = useT()

  const selectADateRowCopies = {
    today: t(`Today`, {
      _context: 'Text for scheduling step in service modal.',
    }),
    none: t(`None`, {
      _context: 'Table cell value for scheduling step in service modal.',
    }),
  }

  const formattedScheduledTime = (
    hours: number | null,
    minutes: number | null
  ) => {
    if (
      (hours === null || hours === 0) &&
      (minutes === null || minutes === 0)
    ) {
      return selectADateRowCopies.none
    }
    return `${hours} h ${minutes} min`
  }

  const newScheduledTime = () => {
    const newTotalMinutes = minutesScheduled + totalMinutesScheduled
    const { hours, minutes } = toHoursAndMinutes(newTotalMinutes)
    return formattedScheduledTime(hours, minutes)
  }

  return (
    <TableRow
      expandable
      className="service-vert-align-top"
      onClick={() => {
        setSelectedDate(date)
      }}
    >
      <TableBodyCell>
        <Inline space={2}>
          <Inline space={4} className="radio-date-wrapper">
            <Box className="vd-pl4">
              <Radio
                checked={
                  selectedDate
                    ? compareDates(new Date(selectedDate), new Date(date)) === 0
                    : false
                }
                readOnly
              />
            </Box>
            <Box>
              <Text tag="p">{formattedCurrentDate}</Text>
              {shouldUseTodayFlag && (
                <Flag
                  className="today-flag-mobile"
                  content={selectADateRowCopies.today}
                />
              )}
            </Box>
          </Inline>

          {shouldUseTodayFlag && (
            <Box>
              <Flag
                className="vd-hide-tablet-portrait"
                content={selectADateRowCopies.today}
              />
            </Box>
          )}
        </Inline>
      </TableBodyCell>
      <TableBodyCell>
        <Text>
          {minutesScheduled === 0
            ? selectADateRowCopies.none
            : formattedScheduledTime(scheduledHours, scheduledMinutes)}
        </Text>
      </TableBodyCell>
      <TableBodyCell>
        <Icon className="arrow-icon" icon="arrow-right" />
      </TableBodyCell>
      <TableBodyCell>
        <Text>{newScheduledTime()}</Text>
      </TableBodyCell>
    </TableRow>
  )
}
